export default function TermsFirstSection({ title, text }) {
  return (
    <section id="terms_first_section">
      <div className="container">
        <div className="terms-wrapper">
          <h1>{title}</h1>
          <p>{text}</p>
        </div>
      </div>
    </section>
  );
}
